const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKoalyLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.467 135.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-6.786 20.707 4.07 42.849 24.252 49.464a37.577 37.577 0 0 0 11.704 1.874 42.364 42.364 0 0 1-8.67 1.838C4.767 55.527-15.343 39.685-17.629 17.783c-2.293-21.911 14.101-41.579 36.616-43.93a42.403 42.403 0 0 1 8.643-.021C15.13-22.925 4.398-13.41 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.06766 0 0 -1.06766 20.637 87.378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-11.436 18.824-36.387 24.557-55.736 12.804a42.37 42.37 0 0 1-7.047-5.367 37.335 37.335 0 0 0 11.378 3.31C-30.34 13.392-11.063-1.988-8.344-23.61c1.756-14-3.874-27.19-13.795-35.464a42.723 42.723 0 0 1 7.803 3.708C5.013-43.615 11.432-18.828 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.06766 0 0 -1.06766 127.832 40.111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.581 20.408-24.839 33.239-45.245 28.658-20.41-4.574-33.239-24.834-28.658-45.24 4.581-20.412 24.839-33.236 45.25-28.658C-8.248-40.659 4.576-20.399 0 0m-62.609-11.787a3.5 3.5 0 0 0 0 7.001 3.506 3.506 0 0 0 3.498-3.504 3.507 3.507 0 0 0-3.498-3.497m33.567-31.722c-10.38-2.329-21.698 8.747-25.295 24.738-3.588 15.988 1.911 30.841 12.292 33.174 10.38 2.327 21.699-8.749 25.288-24.74 3.585-15.992-1.913-30.84-12.285-33.172M-14.86.798a3.504 3.504 0 0 0-3.504 3.503 3.5 3.5 0 0 0 7.001 0A3.5 3.5 0 0 0-14.86.798",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.06766 0 0 -1.06766 108.929 66.142)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoalyLogoOnly);
export default __webpack_public_path__ + "static/media/koaly_logo_only.04561f9a.svg";
export { ForwardRef as ReactComponent };